/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { Entitlement } from "./Entitlement";
export const ListEntitlementsResponse = core.serialization.object({
    data: core.serialization.list(Entitlement),
});
